import { useGetConfiguration } from './useGetConfiguration';

export const useGetConfigurationProcesses = () => {
  const { data, ...rest } = useGetConfiguration();

  return {
    data: data?.processes,
    ...rest,
  };
};
